import { create } from 'zustand'

interface FolderState {
  selectedFolder: string | null
  selectedFolderName: string
  setSelectedFolder: (folderId: string | null) => void
  currentPage: number
  setCurrentPage: (page: number) => void
  setSelectedFolderName: (folderName: string) => void
}

export const useFolderStore = create<FolderState>((set) => ({
  selectedFolder: '',
  selectedFolderName: '',
  currentPage: 1,
  setSelectedFolder: (folderId) => {
    set({ selectedFolder: folderId })
  },
  setSelectedFolderName: (folderName) => {
    set({ selectedFolderName: folderName })
  },
  setCurrentPage: (page) => set({ currentPage: page })
}))
